import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { formatDate } from "@/shared/utils";
import type { FC } from "react";
import type { AppDatePickerProps } from "../../AppDatePicker";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { AppDatePicker } from "../../AppDatePicker";
import { handleErrors } from "../helpers";
import styles from "./styles.module.scss";

export const FormDatePicker: FC<AppDatePickerProps> = ({ name = "", ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormFieldWrapper name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <AppDatePicker
              ref={ref}
              value={formatDate(value)}
              status={errors[name] ? "error" : ""}
              onChange={(_, dateString) => {
                onChange(dateString);
                props.customOnChange?.();
              }}
              className={classNames({
                [styles["input-error"]]: handleErrors(errors, name),
              })}
              {...props}
            />
          );
        }}
      />
    </FormFieldWrapper>
  );
};
